<!-- Pop up for loadUnit selection -->
<dx-popup
  width="500px"
  height="700px"
  [showTitle]="true"
  title="Auswahl Ladeeinheit"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [visible]="visible()"
  [shading]="true"
  [contentTemplate]="'content'">
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="top"
    location="after"
    [options]="{ icon: 'close', onClick: closeDialog.bind(this) }">
  </dxi-toolbar-item>
  <dxo-position boundaryOffset="0 200" at="top" [of]="'#right-col'" collision="fit"> </dxo-position>
  <div *dxTemplate="let data of 'content'">
    <div class="loadunit-selection">
      <dx-select-box
        [items]="loadunitSelection()"
        [displayExpr]="'name'"
        [valueExpr]="'id'"
        [value]="selectedLoadunitId()"
        (onValueChanged)="onLoadunitChange($event.value)"></dx-select-box>
      <div>
        <div class="loadunit-stats">
          <b>{{ 'PROJECT_PLANNING.LOADUNIT.MAXLOAD' | translate }} </b>
          <span>{{ selectedLoadunit?.maxLoad }} t</span>
        </div>
        <div class="loadunit-stats">
          <b>{{ 'PROJECT_PLANNING.LOADUNIT.MAXVOLUME' | translate }} </b>
          <span>{{ selectedLoadunit?.maxVolume }} m³</span>
        </div>
        <div class="loadunit-stats">
          <b>{{ 'PROJECT_PLANNING.LOADUNIT.TYPE' | translate }} </b>
          <span>{{
            selectedLoadunit ? ('MASTERDATA.LOADUNIT.DTO.TYPE_' + selectedLoadunit.type | translate) : ''
          }}</span>
        </div>
      </div>
      <dx-button text="{{ 'PROJECT_PLANNING.SELECT' | translate }}" (onClick)="handleLoadunitSelected()"></dx-button>
      @if (inAssignmentPlanningMode()) {
        <dx-button text="{{ 'PROJECT_PLANNING.REST_REMAINS' | translate }}" (onClick)="handleRestRemains()"></dx-button>
      }
    </div>
  </div>
</dx-popup>
